export var getAvailabilityState = function (price) {
    // Price is empty meaning that product is not available for purchase.
    if (!price) {
        return 3 /* WhereToBuy */;
    }
    // Try to get availability state as if the price is of product, family or group
    var availabilityState = price.availabilityState;
    if (typeof availabilityState === 'number') {
        return availabilityState;
    }
    // Try to get availability state as if the price is of SFCC product
    var c_availabilityState = price.c_availabilityState;
    if (typeof c_availabilityState === 'number') {
        return c_availabilityState;
    }
    return 3 /* WhereToBuy */;
};
